module.exports = __webpack_public_path__ + "static/krupa-1e3d8c398f1f2c4127f7b951e892cabc.png";